import { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import Tabs from "../../components/Tabs/Tabs"
import { AssService } from '../../services/AssService';
import { use } from 'react';

/*--
    action[0] : pop state parameter
    action[1] : gateway object
    action[2] : function to call when upgrading
--*/
const DetailsGatewayPopUp = ({action,t}) => {
  
    const [openPopup,setOpenPopup] = useState (false);
    const [gateway, setGateway] = useState({});
    const [dongles, setDongles] = useState([]);

    useEffect(()=>{
        return () => {
            setOpenPopup(false);
            setGateway({});
            setDongles([]);
        }
    },[])

    useEffect(()=>{
            setOpenPopup(action[0]);
            if (action[0] === true)
            {
                setGateway(action[1])
            }
    },[action[0]])

    useEffect(()=>{
        if (gateway !=  {})
        {
            getDongles();
        }
    }
    , [gateway])


    async function onCloseModal() {
        try {
          action[0] = false;
          action[2]();
        } catch (e) {
          throw new Error(`API error:${e?.message}`)
        }    
    }

    async function getDongles() {
        if (gateway.components)
        {
            for (let i = 0; i < gateway.components.length; i++) {
                const dongle = gateway.components[i];
                var response  = await AssService.getObject(dongle.resource.id);           
                setDongles((previousDongles)=>([...previousDongles,response]));
            }
        }
    }


    return (
        <Popup open={openPopup} closeOnDocumentClick lockScroll={true} modal onClose={onCloseModal}>
            <div className='popup'>
                <h5>{t('users.gateways.details.title')}</h5>
                <Tabs>
                    <div label={t('objects.details.menus.information')} icon="detail">
                        <div className="container">
                            <div className="row">
                                <div className="col">
                                        <h5>{t('objects.table.header.name')}</h5>
                                        <span>{gateway.realName}</span>
                                    </div>
                                </div>
                            <div className="row">
                                <div className="col">
                                    <h5>{t('objects.details.id')}</h5>
                                    <span>{gateway.id}</span>
                                </div>
                                <div className="col">
                                    <h5>{t('objects.details.user_name')}</h5>
                                    <span>{gateway.userName}</span>
                                </div>
                            </div>
                            <div className="row">
                                {gateway.statuses&&gateway.statuses.map((status,index)=>{
                                    return(
                                        <div className="col">
                                            <h5>{status.name}</h5>
                                            <span>{status.value}</span>
                                        </div>
                                    )   
                                })}
                            </div>
                        </div>
                    </div>
                    <div label={t('objects.details.menus.history')} icon="calendar">
                        <div className="container">
                        </div>
                    </div>
                    <div label={t('users.gateways.details.menus.dongles')} icon="network-chart">
                        <div className="container">
                            
                            {(dongles.length>0)&&dongles.map((dongle,index)=>{
                                console.log(dongle)
                                return(
                                    <>
                                        <h5 className='popup-title'>
                                        {dongle.userName}{dongle.connected?<box-icon size="xs" color="#afe37b" type="solid" name="circle" /> : <box-icon  size="xs" color="red" type="solid" name="circle" />}
                                        </h5>

                                        <div className="row">
                                            <div className="col-4">
                                                ID
                                            </div>
                                            <div className="col-5">
                                                {dongle.id}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-4">
                                                Type
                                            </div>
                                            <div className="col-5">
                                                {dongle.typeName}
                                            </div>
                                        </div>


                                        {dongle.statuses.map((data,index) => {
                                            return(
                                                <div className="row">
                                                    <div className="col-4">
                                                        {data.name}
                                                    </div>
                                                    <div className="col-5">
                                                        {data.value}
                                                    </div>
                                                </div>
                                            )
                                        })}

                                    </>
                                )
                            })}
                        </div>
                    </div>
                </Tabs>
            </div>
        </Popup>
    );
    
}
  
export default DetailsGatewayPopUp;